import Styles from './BrandKitImages.module.scss'
import { VideoDuration } from 'components/VideoDuration/VideoDuration'
import { IMediaFile } from 'components/Design/UploadsTab/Types'
import { Trash2 } from 'blaze-ui/icons'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { useHover } from '@react-aria/interactions'
import cx from 'classnames'
import { LoadingShimmerer } from 'components/LoadingShimmerer/LoadingShimmerer'
import { useState } from 'react'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

interface ImageGridItemProps {
  image: IMediaFile
  onDelete: (id: number) => void
}

export const ImageGridItem = ({ image, onDelete }: ImageGridItemProps) => {
  const { isMobile } = useResponsiveDesign()
  const { isHovered, hoverProps } = useHover({})
  const [isLoading, setIsLoading] = useState<boolean>(true)

  return (
    <div key={image.id} className={Styles.imageContainer} {...hoverProps}>
      <LoadingShimmerer show={isLoading} className={Styles.imageLoadingContainer} />
      <img
        src={image.thumbnail_url || image.source_url}
        alt={image.title || `Image ${image.id}`}
        className={cx(Styles.image, { [Styles.imageGridItemHidden]: isLoading })}
        onError={() => setIsLoading(false)}
        onLoad={() => setIsLoading(false)}
      />
      <div className={cx(Styles.deleteButtonContainer, { [Styles.isHovered]: isHovered || isMobile })}>
        <IconButton
          icon={Trash2}
          size="xs"
          variant="secondary"
          rounded
          data-testid="delete-button"
          onPress={() => {
            if (!image.asset_id) return

            onDelete(image.asset_id)
          }}
        />
      </div>
      {image.duration && <VideoDuration duration={image.duration} />}
    </div>
  )
}
